import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { Grid, InputLabel, makeStyles, FormHelperText } from '@material-ui/core';
import * as filesAction from '../../../redux/actions/filesAction';
import { useDispatch } from 'react-redux';
import { artifactStatusMap, userSelectableArtifactStatus } from '../../../Constants/Files';
import FormControl from '@material-ui/core/FormControl';
import { isTerminalStatus } from '../../../Utils/FileUtils';

//styles
const useStyles = makeStyles((theme) => ({
	modelStatusDropdown: {
		height: '2em',
		minWidth: '10em',
	},
	root: {
		'& svg': {
			verticalAlign: 'middle',
		},
	},
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120,
	},
}));

// Render editable dropdown
const RenderStatusEditableDropDown = ({ status, handleStatusOnChange }) => {
	const fileStatusKeys = Object.keys(artifactStatusMap);
	const classes = useStyles();
	return (
		<FormControl variant="outlined" className={classes.formControl}>
			<InputLabel id="model-status-dropdown">Status</InputLabel>
			<Select
				labelId="model-status-select-outlined-label"
				id="model-status-select-outlined"
				data-cy="model-status-select"
				value={status}
				onChange={handleStatusOnChange}
				label="Status"
				variant="outlined"
				className={classes.modelStatusDropdown}
			>
				{fileStatusKeys.map((key) => {
					const value = artifactStatusMap[key].value;
					const label = artifactStatusMap[key].label;
					// only enable menu items part of userSelectableArtifactStatus.
					return (
						<MenuItem
							value={value}
							key={value}
							disabled={!userSelectableArtifactStatus.has(value)}
							data-cy={value}
						>
							{label}
						</MenuItem>
					);
				})}
			</Select>
			{/* only display published helper text when artifact status is a non-terminal status. */}
			{isTerminalStatus(status) ? '' : <FormHelperText>Select Approved to publish</FormHelperText>}
		</FormControl>
	);
};

// Status dropdown for the files
const ModelStatusDropDown = ({ file, asset, handleManageAssetFileStatusOnChange, toolTipTitle }) => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const status = file.status;
	const handleStatusOnChange = (event) => {
		const newFileStatus = event.target.value;
		if (handleManageAssetFileStatusOnChange) {
			handleManageAssetFileStatusOnChange(newFileStatus);
		} else {
			const actionObj = {
				fileName: file.name,
				assetId: asset.id,
				status: newFileStatus,
			};
			dispatch(filesAction.updateFileReviewStatus(actionObj));
		}
	};
	// default display read only mode. only display editable dropdown on the click of read only mode.
	return (
		<div>
			<Grid container className={classes.root}>
				<RenderStatusEditableDropDown
					status={status}
					handleStatusOnChange={handleStatusOnChange}
				></RenderStatusEditableDropDown>
			</Grid>
		</div>
	);
};

export default ModelStatusDropDown;
